import React, { useState } from 'react'
import AsyncCreatableSelect from 'react-select/async-creatable'
import debounce from 'lodash.debounce'

const LookupSelect = ({
	label,
	value,
	onChange,
	fetchOptions,
	onCreateNew,
	getOptionLabel,
	getOptionValue,
	placeholder = 'Select...',
	isClearable = true,
}) => {
	const [inputValue, setInputValue] = useState('')

	// Map a value object to a react-select compatible format
	const toOption = (item) => ({
		label: getOptionLabel(item),
		value: getOptionValue(item),
		data: item,
	})

	// Load options with debounce
	const loadOptions = debounce(async (input, callback) => {
		try {
			const results = await fetchOptions(input)
			callback(results.map(toOption))
		} catch (err) {
			console.error('LookupSelect fetchOptions failed:', err)
			callback([])
		}
	}, 300)

	// Handle selection
	const handleChange = (option) => {
		onChange(option ? option.data : null)
	}

	// Handle creation of new item
	const handleCreate = async (inputLabel) => {
		try {
			const newItem = await onCreateNew(inputLabel)
			onChange(newItem)
		} catch (err) {
			console.error('LookupSelect create failed:', err)
		}
	}

	return (
		<div style={{ marginBottom: '1rem' }}>
			{label && (
				<label style={{ display: 'block', marginBottom: '0.5rem' }}>
					{label}
				</label>
			)}
			<AsyncCreatableSelect
				placeholder={placeholder}
				value={value ? toOption(value) : null}
				onChange={handleChange}
				onCreateOption={handleCreate}
				loadOptions={loadOptions}
				defaultOptions
				isClearable={isClearable}
				onInputChange={setInputValue}
			/>
		</div>
	)
}

export default LookupSelect
